import { DisbursementMutationDto, DisbursementOverviewDto } from '../registrationConfig'

export const mapDisbursementOverviewDtoToMutation = (dto: DisbursementOverviewDto): DisbursementMutationDto => ({
    userId: dto.user?.id,
    type: dto.type,
    vatType: dto.vatType,
    description: dto.description || undefined,
    date: dto.date,
    rate: dto.rate?.amount,
    currency: dto.rate?.currency,
    fileId: dto.file?.id,
})
